import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

export interface DecodedToken {
  email: string;
  sub: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor() {}

  decodeToken(token: string): DecodedToken | null {
    try {
      return jwtDecode<DecodedToken>(token);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  public getEmailFromToken(token: string): string | null {
    const decoded = this.decodeToken(token);
    return decoded ? decoded.email : null;
  }
}
